type PageName = 'HOME' | 'FILE_LIST' | 'LIFTING_ACTION_SUMMARY' | 'ELECTRICAL_ACTION_SUMMARY' | 'REPORT_DETAILS' | 'FORBIDDEN';

export interface PageType extends Record<string, any> {
  key: string;
  path: string;
  message: string;
  breadcrumbPages: PageName[]; // order is important
}

const Page: Record<PageName, PageType> = {
  HOME: { key: 'HOME', path: '/', message: 'breadcrumb.home', breadcrumbPages: ['HOME'] },
  FILE_LIST: {
    key: 'FILE_LIST',
    path: '/files/:mainUploadId',
    message: 'breadcrumb.import',
    breadcrumbPages: ['FILE_LIST', 'HOME'],
  },
  LIFTING_ACTION_SUMMARY: {
    key: 'LIFTING_ACTION_SUMMARY',
    path: '/files/:mainUploadId/liftingActionSummaryDetails/:uploadId',
    message: 'breadcrumb.file',
    breadcrumbPages: ['LIFTING_ACTION_SUMMARY', 'FILE_LIST', 'HOME'],
  },
  ELECTRICAL_ACTION_SUMMARY: {
    key: 'ELECTRICAL_ACTION_SUMMARY',
    path: '/files/:mainUploadId/electricalActionSummaryDetails/:uploadId',
    message: 'breadcrumb.file',
    breadcrumbPages: ['ELECTRICAL_ACTION_SUMMARY', 'FILE_LIST', 'HOME'],
  },
  REPORT_DETAILS: {
    key: 'REPORT_DETAILS',
    path: '/files/:mainUploadId/reportDetails/:uploadId',
    message: 'breadcrumb.file',
    breadcrumbPages: ['REPORT_DETAILS', 'FILE_LIST', 'HOME'],
  },
  FORBIDDEN: {
    key: 'FORBIDDEN',
    path: '/forbidden',
    message: 'forbidden',
    breadcrumbPages: [],
  },
};

export default Page;
